import type { ButtonProps } from "./Button";
import { Button } from "./Button";
import { IconButton } from "./IconButton";

export const ButtonPrimary = (props: ButtonProps) => (
  <Button type="primary" {...props} />
);
ButtonPrimary.displayName = "ButtonPrimary";

export const ButtonFill = (props: ButtonProps) => (
  <Button type="fill" {...props} />
);
ButtonFill.displayName = "ButtonFill";

export const ButtonGhost = (props: ButtonProps) => (
  <Button type="ghost" {...props} />
);
ButtonGhost.displayName = "ButtonGhost";

export { Button, IconButton };
